/**
 * Pantalla: Mapa
 * Component: PantMapaLots.tsx
 * Llenguatge: TypeScrypt
 * Autors: Jordi Riu
 * Versió: 1.1
 * Data: 19/12/2017
 * (c) Ajuntament de Manresa - dic 2017 - Departament de Sistemes d'Informació
 * Per mostrar indicadors en un mapa
 */

import * as React from 'react';
import { Paper, MenuItem, Checkbox, FormControlLabel } from '@material-ui/core';
import { inject, observer } from 'mobx-react';
import { MapComponent } from '@terrestris/react-geo';
import { IPropsMapa } from '../interfaces/IPropsMapa';
import MapaState from '../states/MapaState';
import AdrWidget from '../controls/AdrWidget';
import MyLayerSwitcher from '../controls/MyLayersSwitcher';
import MyLayerSwitcher2 from '../controls/MyLayersSwitcher2';
import MyZoomToExtent from '../controls/MyZoomToExtent';
import HorizontalCollapse from '../controls/HorizontalCollapse';
import LotDialog from '../controls/LotDialog';
import InfoDialog from '../controls/InfoDialog';
import { EmplaDialog } from '../controls/EmplaDialog';
import { LotOrdDialog } from '../controls/LotOrdDialog';
import { INumero } from '../interfaces/IAdr';
import OlLayerImage from 'ol/layer/Image';
import OlLayerTile from 'ol/layer/Tile';
import 'ol/ol.css';
import 'antd/dist/antd.css';
import '../css/react-geo.css';
import '../css/MyControls.css';
import PantLogin from './PantLogin';
import { ICatLot } from '../interfaces/ICatLot';
import Util from '../config/util';
import Order from '../img/Order.png';

import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import CopyEleAnt from '../controls/CopyEleAnt';

@inject('appState')
@observer
export default class PantMapaLots extends React.Component<IPropsMapa, {}> {
    constructor(props: IPropsMapa) {
        super(props);
        this.mpState = new MapaState(this.props);
        this.props.appState.mpState = this.mpState;

        // this.mpState.sesCod = this.props.match.params.sescod;
        // this.mpState.temCod = this.props.match.params.stname;
        // this.mpState.setTemND(this.props.match.params.stnumber ? parseInt(this.props.match.params.stnumber) : 1);
        // // Construïm la URL de la capa d'indicadors a partir del sescod, del nom i número de estil
        // const parms = {
        //     QFILTER: `sescod='${this.mpState.sesCod}'`,
        //     SSTYLES: (this.mpState.temCod ? `${this.mpState.temCod}#${this.mpState.temND.toString()}` : ''),
        //     time: new Date().getTime().toString() // Per evitar la cache de servidor
        // }
        // this.mpState.isEvalTheme().then((res: boolean) => {
        //     this.props.appState.loadState.setIsLoading(true);
        //     if (res) {
        //         this.mpState.evalTheme().finally(() => {
        //             this.mpState.addLayer('ELELOTS', this.props.appState.mapConfig.wmsELEUrl, parms, this.props.lotsLayer, true, true, true);
        //             this.props.appState.loadState.setIsLoading(false);
        //         });
        //     } else {
        //         this.mpState.addLayer('ELELOTS', this.props.appState.mapConfig.wmsELEUrl, parms, this.props.lotsLayer, true, true, true);
        //         this.props.appState.loadState.setIsLoading(false);
        //     }
        // }).catch((reason: any) => { this.props.appState.notiState.showMessage(String(reason), 'error')});
        // Per el canvi de mida de las pantalla
        this.mpState.updateWindowSize();
    }

    // Porpietats per defecte
    static defaultProps = {
        baseLayer: 'base',
        parceLayer: 'PLPARCE',
        rparceLayer: 'PLRPARCE',
        adrLayer: 'adr',
        lotsLayer: 'ELELOTS',
        fansLayer: 'ELEFAROLES'
    };

    // El estat del mapa
    private mpState: MapaState;

    // Per llegir l'estat dels lots només el primer cop
    private initialGetCatsLots: boolean = false;

    // Hem tancat el diàleg del LOT
    private handleCloseLOTDlg = (cat: number) => {
        if (cat >= 0)
        {
            this.mpState.setLotCat(cat);
        } else {
            this.mpState.elementData = null;
            this.mpState.setSelect(this.mpState.lotsLayer, '');
        }
    }

    // Hem tancat el diàleg d'informació'
    private handleCloseInfoDlg = () => {
        this.props.appState.showInfo(false);
    }

    // Hem tancat el diàleg d'emplaçaments'
    private handleCloseEmplaDlg = () => {
        this.props.appState.showEmpla(false);
    }

    // Hem tancat el diàleg de copiar lots o emplaçaments'
    private handleCloseCopyEleAntDlg = () => {
        this.props.appState.showCopyEleAnt(false, '', undefined);
    }

    updateDimensions() {
        this.mpState.updateWindowSize();
    }
    
    // Per posar si cal la resposta a l'event de resize
    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions.bind(this));
    }
      
    // Per treure si cal la resposta a l'event de resize
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions.bind(this));
    }
    
    // Hem triat una finca o una adreça del control de text
    private handleOnChange = (e?: INumero) => {
        if (e) {
            if (e.NUMCOD) {
                this.mpState.setFIDFromNumCod(e.NUMCOD);
                this.mpState.setHCExpanded(false);
            } else {
                this.mpState.setFIDFromNumCod(0);
            }
        } else {
            this.mpState.setFIDFromNumCod(0);
        }
    }

    // Per posar l'estat del HorizontalCollapse
    private handleHCToggle = (expanded: boolean) => {
        this.mpState.setHCExpanded(!this.mpState.hcExpanded);
    }

    // Per posar l'estat del HorizontalCollapse del Ref Layers
    private handleRLHCToggle = (expanded: boolean) => {
        this.mpState.setRLHCExpanded(!this.mpState.rlHCExpanded);
    }

    /**
     * Canviem la visibilitat d'una capa
     * @param event Event que ens passa el control
     * @param layer La capa qeu volem canviar la visibilitat
     */
    private handleLayerClick = (event, layer: OlLayerTile | OlLayerImage) => {
        const vis: boolean = !layer.getVisible();
        layer.setVisible(vis);
        this.mpState.rlAux++;
    }

    /**
     * Volem ordenar un lot (obrim el diàleg)
     * @param event 
     * @param cat 
     */
    private handleLotOrdClick = (event, cat: number) => {
        this.props.appState.setLotOrdCat(cat);
    }

    // Hem tancat el diàleg d'emplaçaments'
    private handleCloseLotOrdDlg = () => {
        this.props.appState.setLotOrdCat(0);
    }

    render () {
        if (!this.props.appState.configOk) {
            return null;
        }
        if (!this.props.appState.usr.sesCod)
        {
            if (this.mpState.lotsLayer)
            {
                this.mpState.removeLotsLayer();
            }
            return (<PantLogin appState={this.props.appState}/>);
        }

        if (!this.initialGetCatsLots) {
            this.initialGetCatsLots = true;
            this.mpState.getCatsLots();
        }

        if (!this.mpState.lotsLayer)
        {
            this.mpState.addLotsLayer();
        }

        const w: number = this.mpState.width;
        const wx:string = (w - 165).toString() + 'px';
        const h: number = this.mpState.height - 120; // Alçada total menys titols
        const hx: string = h.toString() + 'px';
        const lx: string = 'calc(50% - ' + ((w / 2) - 20) + 'px)'; // Ampalda total - ((Amplada mapa / 2) + marge)
        const bx: string = 'calc(100% - ' + (h + 48 + 48).toString() + 'px)'; // Alçada total - (Alçada dialeg + alçada adreça + alcada collapse + marge)
        const lxr: string = 'calc(50% - ' + ((w / 2) - 50) + 'px)'; // Ampalda total - ((Amplada mapa / 2) + marge (amb botons + o-))
        const txr: string = '122px';
        const wxr: string = (w - 50).toString() + 'px';
        const rhc: string = '175px'; // Posició (dreta) del control de capes
        const thc: string = '120px';  // Posició (superioir) del control de capes

        return (
            <Paper style={{margin: 'auto', padding: 0, width: w, height: h }}>
                <table>
                    <tbody>
                        <tr>
                            <td>
                                {this.mpState.adrWebApi && <HorizontalCollapse
                                    style={{zIndex: 2, backgroundColor: 'rgba(250, 250, 250, 0.8)', position: 'absolute', left: lxr, top: txr}}
                                    expandedWidth={wxr}
                                    expanded={this.mpState.hcExpanded}
                                    onToggleExpanded={this.handleHCToggle}
                                >
                                    <AdrWidget
                                        proxyWebApi={this.mpState.adrWebApi}
                                        numCod={this.mpState.numCod}
                                        onChange={this.handleOnChange}
                                        floatingLabelText="Centrar el mapa per adreça"
                                    />
                                </HorizontalCollapse>}
                                {this.mpState.adrWebApi && this.mpState.refLayers.length > 0 && <HorizontalCollapse
                                    style={{zIndex: 2, backgroundColor: 'rgba(250, 250, 250, 0.9)', position: 'absolute', right: rhc, top: thc}}
                                    expandedWidth={'200px'}
                                    expandToLeft={true}
                                    expanded={this.mpState.rlHCExpanded}
                                    onToggleExpanded={this.handleRLHCToggle}
                                >
                                    <MenuItem key={'rlys'} >Capes</MenuItem>
                                    {this.mpState.refLayers.map((layer: OlLayerTile | OlLayerImage, index: number) => { return (<><FormControlLabel
                                        control={<Checkbox
                                            key={'rl' + (this.mpState.rlAux + index).toString()}
                                            checked={layer.getVisible()}
                                            onChange={(event) => this.handleLayerClick(event, layer)}
                                        />}
                                        label={layer.get('name')}
                                    /><br/></>); })}
                                </HorizontalCollapse>}
                                {this.mpState.olmap && <MapComponent map={this.mpState.olmap} style={{width: wx, height: hx, cursor: 'crosshair'}}/>}
                                {this.mpState.olmap && <MyZoomToExtent map={this.mpState.olmap} tooltip="Zoom total" extent={this.mpState.initialExtent}/>}
                                {this.mpState.baseLayers.length === 2 && <MyLayerSwitcher
                                    style={{
                                        position: 'absolute',
                                        bottom: bx,
                                        left: lx,
                                        zIndex: 2
                                    }}
                                    map={this.mpState.olmap}
                                    layers={this.mpState.baseLayers}
                                />}
                                {this.mpState.baseLayers.length > 2 && <MyLayerSwitcher2 
                                    style={{
                                        position: 'absolute',
                                        bottom: bx,
                                        left: lx,
                                        zIndex: 2,
                                        backgroundColor: 'rgba(250, 250, 250, 0.8)'
                                    }}
                                    map={this.mpState.olmap}
                                    layers={this.mpState.baseLayers}
                                />}
                            </td>
                            <td style={{verticalAlign: 'top'}}>
                                <table style={{border: '1px solid black', borderCollapse: 'collapse'}}>
                                    <tbody>
                                        <tr>
                                            <th style={{border: '1px solid black'}}>CAT</th>
                                            <th style={{border: '1px solid black'}}>LOTS</th>
                                            <th style={{border: '1px solid black'}}>FANALS</th>
                                            <th style={{border: '1px solid black'}}>ORD</th>
                                        </tr>
                                        {this.mpState.catsLots.map((catLot: ICatLot, i: number) => { 
                                            let stl = {
                                                border: '1px solid black', 
                                                color: Util.isDark(this.props.appState.mapConfig.categories[i].color) ? '#ffffff' : '#000000',
                                                backgroundColor: this.props.appState.mapConfig.categories[i].color,
                                                textAlign: 'center' as any
                                            };
                                            return (
                                            <tr key={i}>
                                                <td style={stl}>{catLot.cat ? catLot.cat : '-'}</td>
                                                <td style={stl}>{catLot.nLots}</td>
                                                <td style={stl}>{catLot.nFanals}</td>
                                                <td style={stl}>
                                                    {catLot.cat > 0 && catLot.nLots > 0 && <img 
                                                        title="Ordenar"
                                                        alt="Ordenar"
                                                        src={Order}
                                                        style={{ width: '15px', height: '15px', cursor: 'pointer'}}
                                                        onClick={(event) => this.handleLotOrdClick(event, catLot.cat)}
                                                    />}
                                                </td>
                                            </tr>); })}
                                            <tr key={99}>
                                                <td style={{border: '1px solid black', textAlign: 'left' as any}} colSpan={2}>Triades</td>
                                                <td style={{border: '1px solid black', textAlign: 'center' as any}}>{this.mpState.catsLots.map((catLot: ICatLot) => catLot.cat ? catLot.nFanals : 0).reduce((prev, next) => prev + next)}</td>
                                                <td></td>
                                            </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>
                {!!this.mpState.elementData && <LotDialog lot={this.mpState.elementData}
                    categories={this.mpState.mapConfig.categories}
                    catsLots={this.mpState.catsLots}
                    onClose={this.handleCloseLOTDlg} 
                />}
                {!!this.props.appState.showInfoDlg && <InfoDialog
                    appState={this.props.appState}
                    onClose={this.handleCloseInfoDlg} 
                />}
                {!!this.props.appState.showEmplaDlg && <DndProvider backend={HTML5Backend}><EmplaDialog
                    appState={this.props.appState}
                    onClose={this.handleCloseEmplaDlg} 
                /></DndProvider>}
                {this.props.appState.lotOrdCat > 0 && <DndProvider backend={HTML5Backend}><LotOrdDialog
                    appState={this.props.appState}
                    mpState={this.mpState}
                    cat={this.props.appState.lotOrdCat}
                    onClose={this.handleCloseLotOrdDlg} 
                /></DndProvider>}
                {!!this.props.appState.showCopyEleAntDlg && <CopyEleAnt
                    appState={this.props.appState}
                    onClose={this.handleCloseCopyEleAntDlg} 
                />}
            </Paper>
        );
    }
}